module.exports = ".mat-column-acciones {\n  -webkit-box-flex: 0 !important;\n      -ms-flex: 0 0 25% !important;\n          flex: 0 0 25% !important;\n  width: 25% !important; }\n\n.mat-row {\n  min-height: 36px !important;\n  padding-left: 5% !important;\n  padding-right: 5% !important; }\n\n.low-line {\n  border-bottom: 1px solid #b8b8b8; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/compania/sucursales/sucursal.component.scss
// module id = ./src/app/compania/sucursales/sucursal.component.scss
// module chunks = main